// Valou → Place Mapping
// Definiert welche Place-Attribute zu welchem Valou-Bereich passen

import type { ValouAreaId } from '../types/valou';
import type { MoodLabel, ActivityLabel, CommunityFeature } from '../types';

export interface ValouPlaceMapping {
  moods: MoodLabel[];
  activities: ActivityLabel[];
  community: CommunityFeature[];
}

// Mapping: Welche Place-Attribute zu welchem Valou-Bereich passen
export const VALOU_PLACE_MAPPINGS: Record<ValouAreaId, ValouPlaceMapping> = {
  privatesLeben: {
    moods: ['Gemütlich & vertraut', 'Ruhig & entspannt', 'Offen & einladend'],
    activities: ['Einfach da sein', 'Plaudern & Zuhören'],
    community: ['Nachbarschaftstreff', 'Generationen-Mix', 'Kinder willkommen', 'Haustiere willkommen'],
  },
  persoenlichkeitSkills: {
    moods: ['Kreativ & inspirierend', 'Offen & einladend', 'Lebendig & gesellig'],
    activities: ['Kreativ sein', 'Neue Menschen kennenlernen'],
    community: ['Offene Runde', 'Regelmäßige Treffen'],
  },
  taetigkeit: {
    moods: ['Ruhig & entspannt', 'Kreativ & inspirierend'],
    activities: ['Lesen & Schmökern', 'Kreativ sein'],
    community: ['Regelmäßige Treffen'],
  },
  stilWirkung: {
    moods: ['Lebendig & gesellig', 'Offen & einladend', 'Kreativ & inspirierend'],
    activities: ['Neue Menschen kennenlernen', 'Events & Veranstaltungen', 'Stammtisch besuchen'],
    community: ['Offene Runde'],
  },
  ressourcenMittel: {
    moods: ['Offen & einladend', 'Lebendig & gesellig'],
    activities: ['Neue Menschen kennenlernen', 'Stammtisch besuchen', 'Plaudern & Zuhören'],
    community: ['Stammtisch vorhanden', 'Offene Runde', 'Nachbarschaftstreff', 'Regelmäßige Treffen'],
  },
  gesundheit: {
    moods: ['Ruhig & entspannt', 'Gemütlich & vertraut'],
    activities: ['Einfach da sein', 'Lesen & Schmökern'],
    community: ['Barrierefrei', 'Generationen-Mix'],
  },
};

// Mindest-Score damit ein Valou-Bereich als passend gilt
export const VALOU_MATCH_THRESHOLD = 2;
